import { render, staticRenderFns } from "./clienti.vue?vue&type=template&id=626c067a&"
import script from "./clienti.vue?vue&type=script&lang=js&"
export * from "./clienti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports